import { schema } from 'normalizr';
import { SCHEMA_TYPE_CATALOG_CONFIGS } from '../constants/schemaTypes';
import credentialSchema from './credential';
import orgSchema from './org';
import userSchema from './user';

const catalogConfigSchema = new schema.Entity(SCHEMA_TYPE_CATALOG_CONFIGS, {
  owner: userSchema,
  org: orgSchema,
  data_credentials: credentialSchema,
});

export default catalogConfigSchema;
